export default __webpack_public_path__ + "static/media/powered-by-doselect.e056deae.svg";